import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-preview-matrix-single-choice',
  templateUrl: './preview-matrix-single-choice.component.html',
  styleUrls: ['./preview-matrix-single-choice.component.scss']
})
export class PreviewMatrixSingleChoiceComponent {
  @Input() questions: any;
  @Input() isReadOnly: boolean;
  @Input() displayMode: string;
  constructor(public sanitizer: DomSanitizer) { }

}
